import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './coupon-qr-dialog.component.html',
  styleUrls: ['./coupon-qr-dialog.component.scss']
})
export class CouponQRDialogComponent implements OnInit {

  public coupon: any = {};

  constructor(
    public dialogRef: MatDialogRef<CouponQRDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.coupon = _.has(this.data, 'coupon') ? this.data.coupon : {};
  }

}
